/* iRide EQ — In-stock-first collection sorting.
   Moves sold-out products to the end of every collection grid,
   without removing them (keeps pages shoppable + protects ranks). */
(function () {
  function reorder() {
    var grids = document.querySelectorAll('#CollectionSection .grid, .collection-grid, [data-scroll-to] .grid');
    if (!grids.length) {
      grids = document.querySelectorAll('.grid');
    }
    grids.forEach(function (grid) {
      var soldOut = [].slice.call(grid.querySelectorAll(':scope > .grid-product--sold-out'));
      if (!soldOut.length) return;
      soldOut.forEach(function (el) { grid.appendChild(el); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorder);
  } else {
    reorder();
  }
  // Impulse re-renders grids on sort/filter (History API) — re-apply
  document.addEventListener('page:load', reorder);
  window.addEventListener('shopify:section:load', reorder);
})();
